// extracted by mini-css-extract-plugin
module.exports = {"product-card":"centeredheader_product-card__8nslD","container":"centeredheader_container__Lgfa3","container__body":"centeredheader_container__body__cmWqW"};